import { createReducer, on } from '@ngrx/store';
import * as actions from './history.actions';

export const stateInitial: any[] = [];

const _historyReducer = createReducer(stateInitial,
	on(actions.clean, (state) => stateInitial),
	on(actions.update, (state, { lastProjects }) => [...lastProjects]),
);

export function historyReducer(state, action) {
	return _historyReducer(state, action);
}
